import { useMemo } from 'react';
import { Destination, DestinationAction } from '../../../../shared/interfaces/destination';
import { ResolvedComponent } from '../../../../routing/ResolvedComponent';
import { EntityDisplayConfig } from '../../../../shared/components/EntityDisplayConfig/EntityDisplayConfig';
import { DestinationAPI } from '../../../api/DestinationAPI';
import { EntityDisplayConfigFactory } from '../../../../shared/factory/entityDisplayConfigFactory';
import { EntityAction } from '../../../../entity-actions/interfaces/entity-actions';
import { DESTINATION_INLINE_EDIT_ACTION } from '../../../DestinationActions/constant/destination-actions';

export function DestinationConfigurationTab({ destination }: { destination: Destination }) {
  const actionsProps = useMemo(() => {
    const actions: EntityAction<DestinationAction>[] = destination.actions
      .filter(action => action.action === DestinationAction.EDIT)
      .map(editAction => ({
        ...editAction,
        ...DESTINATION_INLINE_EDIT_ACTION,
        routeOptions: {
          route: '../edit',
          options: {
            relative: 'path'
          }
        }
      }));

    return {
      actions,
      entity: destination
    };
  }, [destination]);

  const displayConfigResolver = async () => {
    return DestinationAPI.getDestinationDisplayConfigDetails(destination.id).then(res =>
      EntityDisplayConfigFactory(res.data)
    );
  };

  return (
    <ResolvedComponent
      Component={EntityDisplayConfig}
      componentProps={{
        title: 'Destination Configuration',
        actionsProps,
        containerClassName: 'body-container w-100 h-100'
      }}
      resolve={{
        displayConfig: displayConfigResolver
      }}
    />
  );
}
